import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { UserTrainingPlanService } from '../../user-training-plan/services/user-training-plan.service';
import { EmployeesTrainingPlanService } from '../../employees-training-plan/services/employees-training-plan.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-training-plan-progress',
  templateUrl: './training-plan-progress.component.html',
  styleUrls: ['./training-plan-progress.component.scss'],
})
export class TrainingPlanProgressComponent implements OnInit, OnDestroy {
  trainingPlanProgressKPI: string = '0%';
  trainingPlanProgressKPIColor: string = '#f3be5ce6';
  coreCompleteKPI: string = '0 / 0';
  coreCompleteKPIColor: string = '#f3be5ce6';
  electiveCompleteKPI: string = '0 / 0';
  electiveCompleteKPIColor: string = '#f3be5ce6';
  @Input() myEmployeesTab: boolean = false;
  
  private subscription: Subscription = new Subscription();

  constructor(
    private userTrainingPlanService: UserTrainingPlanService, 
    private employeesTrainingPlanService: EmployeesTrainingPlanService
  ) {}

  ngOnInit(): void {
    if (this.myEmployeesTab) {
      const sub = this.employeesTrainingPlanService.progressKPI$.pipe(
        filter(progressKPI => progressKPI !== null)
      ).subscribe((progressKPI) => {
        this.updateKPIsFromResponse(progressKPI);
      });
      this.subscription.add(sub);
    } else {
      const sub = this.userTrainingPlanService.progressKPI$.pipe(
        filter(progressKPI => progressKPI !== null)
      ).subscribe((progressKPI) => {
        this.updateKPIsFromResponse(progressKPI);
      });
      this.subscription.add(sub);
    }
  }
  
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  updateKPIsFromResponse(progressKPI: any): void {
    const coreTotal = progressKPI.coreComplete + progressKPI.corePending + progressKPI.coreLocked;
    const corePercentage = coreTotal > 0 ? (progressKPI.coreComplete / coreTotal) * 100 : 0;
    
    const electiveTotal = progressKPI.electiveComplete + progressKPI.electivePending + progressKPI.electiveLocked;
    
    // Training Plan Progress (Core percentage)
    this.trainingPlanProgressKPI = `${corePercentage.toFixed(0)}%`;
    this.trainingPlanProgressKPIColor = this.getKPIColor(this.trainingPlanProgressKPI);
    
    // Core Complete KPI
    const coreRatio = coreTotal > 0 ? progressKPI.coreComplete / coreTotal : 0;
    this.coreCompleteKPI = `${progressKPI.coreComplete} / ${coreTotal}`;
    this.coreCompleteKPIColor = coreRatio >= 1 ? '#77c177' : '#f3be5ce6';
    
    // Elective Complete KPI
    const electiveRatio = electiveTotal > 0 ? progressKPI.electiveComplete / electiveTotal : 0;
    this.electiveCompleteKPI = `${progressKPI.electiveComplete} / ${electiveTotal}`;
    this.electiveCompleteKPIColor = electiveRatio >= 1 ? '#77c177' : '#f3be5ce6';
  }

  getKPIColor(kpiValue: string): string {
    const percentage = parseFloat(kpiValue);
    return percentage === 100 ? '#77c177' : '#f3be5ce6';
  }
}
